<template>
  <a-modal
    title="提示"
    v-model="modalShow"
    width="400px"
    @cancel="close"
    destroyOnClose
  >
    <div class="spaceLeft" style="margin-bottom:10px;">
      <a-icon
        theme="filled"
        type="check-circle"
        style="color:#52c41a;font-size:18px;margin-right:8px;"
      />
      <span style="font-size:16px;"
        >您提交的<span style="font-weight:bold">{{ total }}</span
        >笔查验申请中：</span
      >
    </div>
    <div v-if="+pass > 0" style="margin-left:27px">
      <span style="font-weight:bold">{{ pass }}</span
      >笔查验已通过
      <a-button type="link" @click="toListTab('checkSuccess')">查看</a-button>
    </div>
    <div v-if="+reject > 0" style="margin-left:27px">
      <span style="font-weight:bold">{{ reject }}</span
      >笔查验不通过
      <a-button type="link" @click="toListTab('checkRefuse')">查看</a-button>
    </div>
    <template slot="footer">
      <a-button type="primary" class="btn-blue" @click="goBack()"
        >确定</a-button
      >
    </template>
  </a-modal>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      modalShow: false,
      total: 0,
      pass: 0,
      reject: 0
    };
  },
  computed: {},
  methods: {
    open({ total, pass, reject }) {
      this.total = total;
      this.pass = pass;
      this.reject = reject;
      this.modalShow = true;
    },
    close() {
      this.modalShow = false;
      this.total = 0;
      this.pass = 0;
      this.reject = 0;
      this.goBack();
    },
    toListTab(tabCur) {
      this.close();
      this.MENUAPI.goToOneTab({
        path: "bill-manage/receivable",
        query: {
          tabCur: tabCur
        }
      });
    },
    goBack() {
      this.MENUAPI.goToOneTab({
        path: "bill-manage/receivable"
      });
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/bill-manage/receivable/receivable-import-reslut.vue